import { Routes } from '@angular/router';
import { GeotechnicalAnalysisComponent } from './pages/geotechnical-analysis/geotechnical-analysis.component';
import { GeoTechnicalAnalysisReportComponent } from './pages/geo-technical-analysis-report/geo-technical-analysis-report.component';
import { DocGuard } from '../../@core/guards/doc.guard';
import { SubscriptionGuard } from '../../@core/guards/subscription.guard';

/**
 * Routes for the Geotechnical Analysis feature module.
 *
 * GEOTECHNICAL_ANALYSIS_LAYOUT_ROUTES: child routes that live inside the AppLayoutComponent shell
 *   (require auth + subscription – enforced by the parent in app.routes.ts).
 *
 * GEOTECHNICAL_ANALYSIS_TOP_ROUTES: top-level routes that sit outside the layout shell
 *   (same pattern as the `edit-document` route).
 */

/** Route registered under the AppLayoutComponent children (with guards inherited from parent). */
export const GEOTECHNICAL_ANALYSIS_LAYOUT_ROUTES: Routes = [
    {
        path: 'geotechnical-analysis',
        component: GeotechnicalAnalysisComponent,
        data: { breadcrumb: 'Geotechnical analysis' },
    },
];

/** Top-level routes outside the AppLayoutComponent shell. */
export const GEOTECHNICAL_ANALYSIS_TOP_ROUTES: Routes = [
    {
        path: 'geotechnical-analysis-report',
        component: GeoTechnicalAnalysisReportComponent,
        canActivate: [DocGuard, SubscriptionGuard],
        children: [
            {
                path: 'share',
                canActivate: [DocGuard],
                component: GeoTechnicalAnalysisReportComponent,
            },
        ],
    },
];
